import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledProgressBar = styled.div`
    justify-content: space-between;
    width: auto;
    max-width: 70%;
    margin-right: auto;
    margin-left: auto;
    @media ${breakpoints.xs} {
        width: 100%;
        max-width: unset;
    }

    .label-container {
        display: flex;
        justify-content: space-between;
        text-align: center;
        @media ${breakpoints.xs} {
            justify-content: space-evenly;
        }

        span {
            max-width: 200px;
            margin-top: 1.5rem;
            font-size: var(--size-18);
            font-style: normal;
            font-weight: var(--weight-600);
            line-height: 25px;
            color: var(--color-secondary);
            text-align: center;
            text-transform: uppercase;
            @media ${breakpoints.xs} {
                width: 100px;
                font-size: var(--size-12);
                line-height: 16px;
            }
        }
    }

    .progressbar-layout {
        display: flex;
        align-items: center;
        width: 82.5%;
        margin-right: auto;
        margin-left: auto;
        @media ${breakpoints.sm} {
            width: 77.5%;
        }

        .bar-layout {
            position: relative;
            width: 100%;
            height: 4px;
            margin-right: 1rem;
            margin-left: 1rem;
            background: var(--color-grey-700);
            border-radius: 50px;

            .filler {
                height: 100%;
                background: var(--color-secondary);
                border-radius: inherit;
            }
        }
    }
`;
